module.exports = __webpack_public_path__ + "media/iconic/bullhorn-c8171507.svg";